import moment from 'moment';

import { TravelStatusEnum } from 'types';

import { ITravelStatus } from '../../../../../types';
import { getFormatDateFromStoreDate } from 'shared-components';

interface ITravelStatusDescriptionProps {
  travelStatus: ITravelStatus;
}

export const TravelStatusDescription = ({ travelStatus }: ITravelStatusDescriptionProps) => {
  const tStatus = travelStatus.status || TravelStatusEnum.None;

  const youToldText = 'You have told us';
  const pleaseUpdateText = 'Please update this when your status changes.';

  switch (tStatus) {
    case TravelStatusEnum.None: {
      return <>You have not set a travel status.</>;
    }
    case TravelStatusEnum.Booked: {
      return (
        <>
          {youToldText} you are{' '}
          <b>
            Booked to Arrive on{' '}
            {moment(getFormatDateFromStoreDate(travelStatus.bookedDate), 'DD/MM/YYYY').format('DD MMM YYYY')}
          </b>
          . {pleaseUpdateText}
        </>
      );
    }
    case TravelStatusEnum.TravelCancelled: {
      return (
        <>
          {youToldText} your <b>travel is cancelled</b>. {pleaseUpdateText}
        </>
      );
    }
    case TravelStatusEnum.TravelPrevented: {
      return (
        <>
          {youToldText} your <b>travel is prevented</b>. {pleaseUpdateText}
        </>
      );
    }
    case TravelStatusEnum.NoBookingYet: {
      return (
        <>
          {youToldText} have <b>no booking yet</b>. {pleaseUpdateText}
        </>
      );
    }
    case TravelStatusEnum.Arrived: {
      return (
        <>
          {youToldText} you{' '}
          <b>
            arrived on{' '}
            {moment(getFormatDateFromStoreDate(travelStatus.arrivalDate), 'DD/MM/YYYY').format('DD MMM YYYY')}
          </b>
          .
        </>
      );
    }
    case TravelStatusEnum.AlreadyInUk: {
      return (
        <>
          {youToldText} you are <b>already in the UK</b>.
        </>
      );
    }
    case TravelStatusEnum.Withdraw: {
      return (
        <>
          {youToldText} you <b>intend to withdraw</b>.
        </>
      );
    }
    case TravelStatusEnum.Defer: {
      return (
        <>
          {youToldText} you <b>intend to defer</b>.
        </>
      );
    }
  }
  return <></>;
};

interface ITravelStatusColorProps {
  travelStatus: TravelStatusEnum;
}

export const statusColorScheme = ({ travelStatus }: ITravelStatusColorProps) => {
  switch (travelStatus) {
    case TravelStatusEnum.None:
    case TravelStatusEnum.Booked:
    case TravelStatusEnum.TravelCancelled:
    case TravelStatusEnum.TravelPrevented:
    case TravelStatusEnum.NoBookingYet:
      return 'orange';

    case TravelStatusEnum.Defer:
    case TravelStatusEnum.Withdraw:
      return 'gray';

    case TravelStatusEnum.AlreadyInUk:
    case TravelStatusEnum.Arrived:
      return 'green';

    default:
      return 'orange';
  }
};
